var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('ChipList',{attrs:{"item":{items: _vm.items_chips}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }